import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import AcceptedIssuesReasonModal from '../../pages/RedTeamIssueList/AcceptedIssuesReasonModal';
import AcceptedIssuesHistory from '../../pages/RedTeamIssueList/AcceptedIssuesHistory';
import AxiosContext from '../../helpers/AxiosContext';
import GeneralIssueInfo from '../GeneralIssueInfo/GeneralIssueInfo';
import DetailsTable from '../DetailsTable/DetailsTable';

import './IssueInformation.scss';

const IssueInformation = (props) => {
    const axios_api = useContext(AxiosContext).axios;
    const readOnly = useSelector((state) => state.Auth?.user?.readOnly);
    const issue = props.selected?.general_issue || null;
    const selected = props.selected || null;
    const patchUrl = props.patchUrl || null;
    const displayFalsePositiveButton = props.displayFalsePositiveButton || false;
    const toggleFalsePositive = props.toggleFalsePositive;
    const toggleAccepted = props.toggleAccepted;
    const displayAccepted = props.displayAccepted;
    const getUpdateUrl = props.getUpdateUrl;
    const toolNameMapping = props.toolNameMapping || {};

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [falsePositive, setFalsePositive] = useState(null);
    const [accepted, setAccepted] = useState(null);

    useEffect(() => {
        if (selected) {
            setFalsePositive(selected.false_positive);
            setAccepted(selected.accepted);
        }
    }, [selected]);

    const changeFalsePositive = async () => {
        let url = patchUrl;
        // Hotfix to differentiate Burp Suite issues from Nuclei issues
        if (selected.template_id) {
            url = getUpdateUrl('application issues');
        }
        let res = await axios_api.patch(`${url}/${selected.id}`, { false_positive: !falsePositive }).catch((e) => {
            console.log(e);
        });
        if (res) {
            setFalsePositive(!falsePositive);
            toggleFalsePositive(selected.id);
        }
    };

    const getUpdateButton = () => {
        // Hotfix to disallow updates for Cloud Guard reports which are stored remotely as well
        if (selected.first_detected) return (<></>)

        if (!readOnly) {
            if (displayFalsePositiveButton) {
                if (patchUrl) {
                    return (
                        <Button
                            block
                            color={falsePositive ? 'primary' : 'warning'}
                            onClick={changeFalsePositive}
                            className="set-button">
                            {falsePositive ? 'Unset' : 'Set'} False Positive
                        </Button>
                    );
                }
            } else {
                return (
                    <Button
                        block
                        color={accepted ? 'primary' : 'warning'}
                        onClick={() => {
                            setShowConfirmationModal(true);
                        }}
                        className="set-button">
                        {accepted ? 'Unmark' : 'Mark'} as Resolved
                    </Button>
                );
            } 
        }        
        return '';
    };

    return (
        <div className="issue-information">
            {getUpdateButton()}
            <GeneralIssueInfo selected={selected} />
            <DetailsTable objectDetails={selected} toolNameMapping={toolNameMapping} />

            {showConfirmationModal && (
                <AcceptedIssuesReasonModal
                    showModal={showConfirmationModal}
                    setShowModal={setShowConfirmationModal}
                    accepted={accepted}
                    setAccepted={setAccepted}
                    issueType={issue.category}
                    selectedIds={[selected.id]}
                    generalIssue={selected.general_issue}
                    toggleAcceptedIssue={toggleAccepted}
                />
            )}
            {displayAccepted && selected?.accepted_history?.length > 0 && (
                <AcceptedIssuesHistory acceptedIssues={selected.accepted_history} />
            )}
        </div>
    );
};

export default IssueInformation;
